<template>
  <div>

    <div class="SpotlightKutu">

      <div class="input">
        <el-input
          :disabled="lo"
          placeholder="Arama Yapın"
          v-model="Kelime"
          @keyup.enter.native="Getir">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <a @click="Kapat">
          <i v-if="Kelime && !lo" class="el-icon-close"></i>
          <i v-if="lo" class="el-icon-loading"></i>
        </a>
      </div>
      <div v-if="Kelime.length>3" class="aramasonuc">
        <div style="padding: .25rem 0.75rem;margin: 0" v-if="!Sorgu" class="alert alert-secondary" role="alert">
          <small><b>{{Kelime}}</b> Arama Sonuçları için Enter tuşuna basınız</small>
        </div>
        <!--div style="padding: .25rem 0.75rem;margin: 0" v-if="Sonuc && Sorgu" class="alert alert-success"
             role="alert">
          <small><b>{{ArananKelime}}</b> aramasına ait {{Sayi}} adet sonuç bulundu.</small>
        </div-->
        <div style="padding: .25rem 0.75rem;margin: 0" v-if="!Sonuc && Sorgu" class="alert alert-danger"
             role="alert">
          <small><b>{{ArananKelime}}</b> aramasına ait sonuç bulunamadı.</small>
        </div>
        <ul>
          <li v-for="k in Kisi">
            <div class="aramasonucbilgi">
              <h2>{{k.AdSoyadText}}</h2>
              <h3><b class="text-primary">{{k.Telefon}}</b> {{k.Bina}} {{k.Kat}}.Kat {{k.kNo}} No</h3>
            </div>
            <div class="aramasonuclink">
              <el-tooltip class="item" effect="dark" content="Tahsilat Al" placement="right">
                <a @click="Link('/vezne/tahsilat/'+k.Kisi_id)" class="aramavezne" tag="a"><i
                  class="el-icon-bank-card"></i>
                </a>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Kişi Ekranı" placement="right">
                <a @click="Link('/yonetim/kisi/'+k.Kisi_id)" class="aramakisi" tag="a"><i class="el-icon-link"></i>
                </a>
              </el-tooltip>
            </div>
            <div class="aramasonuctutar">
              <div class="aramaodenecek">{{k.Tutar}}</div>
              <div v-if="k.Zam" class="aramazam"><sup>ZAM</sup> {{k.Zam}}</div>
              <div v-if="k.Icra" class="aramazam"><sup>İCRA</sup> {{k.IcraOdenecek}}</div>
            </div>
          </li>
          <li v-for="k in Cari">
            <div class="aramasonucbilgi">
              <h2>{{k.Unvan}}</h2>
              <h3>{{k.Telefon}} - {{k.Mail}} </h3>
            </div>
            <div class="aramasonuclink">
              <el-tooltip class="item" effect="dark" content="Cari Ekranı" placement="right">
                <a @click="Link('/muhasebe/cari/'+k.id)" class="aramakisi" tag="a"><i class="el-icon-link"></i>
                </a>
              </el-tooltip>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <MakbuzDetay v-if="Makbuz" :mNo="Makbuz" @MakbuzDetayModal="Makbuz=null"
                 :MakbuzDetayModal="true"></MakbuzDetay>
  </div>
</template>

<script>
  import Yukleniyor from "./Yukleniyor";
  import MakbuzDetay from "../Pack/Vezne/MakbuzDetay";

  export default {
    components: {MakbuzDetay, Yukleniyor},
    props: ['Spotlight'],
    data() {
      return {
        lo: false,
        Sonuc: false,
        Kelime: '',
        Kisi: null,
        Cari: null,
        Makbuz: null,
        ArananKelime: null,
        Sayi: 0,
        Sorgu: null
      }
    },
    methods: {
      MakbuzGetir(Makbuz) {
        // console.log(Makbuz)
      },
      Link(url) {
        this.$router.push(url);
        this.Kelime = '';
        this.Kisi = null;
        this.Cari = null;
        this.lo = false;
      },
      Kapat() {
        this.lo = false
        this.Sonuc = false
        this.Kelime = ''
        this.Kisi = null
        this.Cari = null
        this.ArananKelime = null
        this.Sayi = 0
        this.Sorgu = null;
        //$("body").removeClass("bodyarama");
      },
      Getir() {
        this.lo = true;
        //$("body").addClass("bodyarama");
        this.$store.dispatch("Post", {
          Kelime: this.Kelime,
          path: 'spesiyal/spotlight'
        })
          .then(response => {
            this.ArananKelime = response.Kelime;
            this.Kisi = response.Kisi;
            this.Cari = response.Cari;
            this.Sonuc = response.Sonuc;
            this.Makbuz = response.Makbuz;
            this.Sayi = response.Say;
            this.lo = false;
            this.Sorgu = true;

          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/Spotlight.vue